module.exports = __webpack_public_path__ + "assets/img/characters_logo.9013fc80.png";